export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_657_SELECT_A_USER': 'Select a User',
    '_763_CLOSE': 'Close'
};
